import { XIcon } from "lucide-react";
import { Button } from "@babackapp/ui/components/button";
import { ReactNode } from "react";

interface DashboardFacetedFilterProps {
  label: string;
  icon?: ReactNode;
  onClear: () => void;
}

export function DashboardFacetedFilter({
  label,
  icon,
  onClear,
}: DashboardFacetedFilterProps) {
  return (
    <div className="inline-flex items-center rounded-md border bg-white px-1.5 text-sm shadow-sm">
      <div className="flex items-center gap-1 px-1 py-1">
        {icon && <span className="text-muted-foreground">{icon}</span>}
        <span className="truncate max-w-[180px]">{label}</span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0 rounded-none hover:bg-muted hover:text-muted-foreground"
        onClick={onClear}
        aria-label="Supprimer le filtre"
      >
        <XIcon className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
